import type { EcosystemDefinition, EcosystemProject } from '@frontend/types'
import type { NodeSelection } from '@frontend/pages/dashboard/types';

interface ProjectTreeSectionProps {
  selected: NodeSelection;
  accessibleEcosystems: string[];
  ecosystemDefs: EcosystemDefinition[];
  projectsByEcosystem: Record<string, EcosystemProject[]>;
  expandedEcosystems: Record<string, boolean>;
  onToggleEcosystemExpanded: (ecosystemId: string) => void;
  onSelectEcosystem: (ecosystemId: string) => void;
  onSelectProject: (ecosystemId: string, projectId: string) => void;
}

export default function ProjectTreeSection({
  selected,
  accessibleEcosystems,
  ecosystemDefs,
  projectsByEcosystem,
  expandedEcosystems,
  onToggleEcosystemExpanded,
  onSelectEcosystem,
  onSelectProject
}: ProjectTreeSectionProps) {
  return (
    <div className="tree-dashboard-sidebar-section">
      <div className="tree-dashboard-sidebar-title">Project Tracking and Management</div>
      {accessibleEcosystems.map((ecoId) => {
        const projects = projectsByEcosystem[ecoId] || [];
        const expanded = expandedEcosystems[ecoId] ?? true;
        return (
          <div key={ecoId} className="tree-dashboard-eco-group">
            <div className="tree-dashboard-node-row">
              <button
                type="button"
                className="tree-dashboard-toggle"
                onClick={() => onToggleEcosystemExpanded(ecoId)}
                aria-label={`Toggle ${ecoId}`}
              >
                {expanded ? '▾' : '▸'}
              </button>
              <button
                type="button"
                className={`tree-dashboard-node ${selected.kind === 'ecosystem' && selected.ecosystemId === ecoId ? 'active' : ''}`}
                onClick={() => onSelectEcosystem(ecoId)}
              >
                {ecosystemDefs.find((e) => e.id === ecoId)?.displayName || ecoId}
                <span className="tree-dashboard-count">{projects.length}</span>
              </button>
            </div>

            {expanded ? (
              <div className="tree-dashboard-project-children">
                {projects.map((project) => (
                  <button
                    key={project.id}
                    type="button"
                    className={`tree-dashboard-node tree-dashboard-node-sub ${selected.kind === 'project' && selected.projectId === project.id ? 'active' : ''}`}
                    onClick={() => onSelectProject(ecoId, project.id)}
                  >
                    {project.name}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
